import { Tag } from 'antd';

interface Props {
  value: number;
}

/**
 * Traffic-light chip for the LLM's reported confidence score:
 *   ≥ 0.85 → green, ≥ 0.65 → yellow, otherwise red.
 */
export function ConfidenceBadge({ value }: Props) {
  const pct = Math.round(value * 100);
  const { color, label } =
    value >= 0.85
      ? { color: 'success', label: 'high' }
      : value >= 0.65
        ? { color: 'warning', label: 'medium' }
        : { color: 'error', label: 'low' };
  return (
    <Tag color={color}>
      {pct}% confidence ({label})
    </Tag>
  );
}
